@if (showLayerSelectionDialog) {
  <loren-layer-selection-dialog
  (finishSelection)="
    finishLayerSelection.emit($event); showLayerSelectionDialog = false
  "
    (cancelSelection)="showLayerSelectionDialog = false"
    [layers]="allMapLayers"
    [defaultValues]="lastSelectedLayers"
    [continueBtnLabel]="'operations.save'"
    [dialogTitle]="'operations.choose_layers'"
    [dialogSubTitle]="'operations.choose_layers_sub_title'"
    >
  </loren-layer-selection-dialog>
}

<div class="{{ btnLook }}" [style.bottom.px]="buttonBottomOffset">
  <button
    mat-fab
    class="map-button map-button-select-layer"
    color="accent"
    (click)="showLayerSelectionDialog = true"
    [disabled]="allMapLayers.length === 0"
    >
    <mat-icon>layers</mat-icon>
  </button>
</div>
